import { Dropdown } from '@brunommsilva/react-foundations';
import { useState } from 'react';

import useAccounts from '../../hooks/accounts/use-accounts';
import { AccountStatus } from '../../models/accounts';

interface Props {
  label: string;
  includeDeleted?: boolean;
  selected?: {
    id: string;
    name: string;
  };
  onSelected: (account?: { id: string; name: string }) => void;
  size?: 'small' | 'medium';
}

const AccountsDropdown = ({
  label,
  selected,
  onSelected,
  includeDeleted = false,
  size,
}: Props) => {
  const [search, setSearch] = useState('');
  const baseFilter = includeDeleted ? {} : { status: AccountStatus.ACTIVE };
  const filter = { ...baseFilter, name: search };

  const { accounts, isLoading } = useAccounts(filter, 1, 5);

  const fetchOptions = (searchString: string) => {
    setSearch(searchString);
  };

  const handleSelected = (id?: string) => {
    if (!id) {
      onSelected(undefined);
      return;
    }
    const account = accounts.find((acc) => acc.id === id);
    if (account) {
      onSelected({
        id: account.id,
        name: account.name,
      });
    } else if (selected && selected.id === id) {
      onSelected(selected);
    } else {
      onSelected({ id, name: '' });
    }
  };

  const selectedOption = selected
    ? { id: selected.id, label: selected.name }
    : undefined;

  return (
    <Dropdown
      label={label}
      selected={selectedOption}
      onSelected={handleSelected}
      fetchOptions={fetchOptions}
      isLoading={isLoading}
      size={size}
      options={
        isLoading
          ? []
          : accounts.map((account) => ({ id: account.id, label: account.name }))
      }
    />
  );
};

export default AccountsDropdown;
